import { newTherapyTemplateAction } from 'src/redux/actions/constant';

const {
  CREATE_NEW_THERAPY_TEMPLATE_SUCCESS,
  CREATE_NEW_THERAPY_TEMPLATE_FAILURE,
  CREATE_NEW_THERAPY_TEMPLATE_LOADING,
  CREATE_NEW_THERAPY_TEMPLATE_RESET,
} = newTherapyTemplateAction;

const initialstate: object = {
  response: null,
  loading: false,
};

export const createNewTherapyTemplateReducer = (state = initialstate, action: any) => {
  switch (action.type) {
    case CREATE_NEW_THERAPY_TEMPLATE_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        loading: false,
      };
    }

    case CREATE_NEW_THERAPY_TEMPLATE_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
      };

    case CREATE_NEW_THERAPY_TEMPLATE_LOADING:
      return {
        ...state,
        loading: true,
      };

    case CREATE_NEW_THERAPY_TEMPLATE_RESET:
      return initialstate;

    default:
      return state;
  }
};
